// extracted by css-extract-rspack-plugin
export default {"image":"CompanyLogo_image__EEmtO"};